import { Overlay } from '@radix-ui/react-dialog';
import { ComponentPropsWithoutRef, ComponentRef, forwardRef } from 'react';

import cn from '@/helpers/cn';

import css from './style.module.scss';

const DialogOverlay = forwardRef<
	ComponentRef<typeof Overlay>,
	ComponentPropsWithoutRef<typeof Overlay>
>(({ className, ...props }, ref) => (
	<Overlay ref={ref} className={cn(css.overlay, className!)} {...props} />
));

export default DialogOverlay;
